import React, { useMemo, useEffect, useState } from 'react'
import { Col, Icon, List as ListAntd, Row, Select } from 'antd'

import { RequestQuoteHotelGroup, RequestQuoteHotelRoom } from 'src/types'

import { currencyMask } from 'src/components/Formik'
import { Text } from 'src/components/Ant'

import { WrapDivMeta, WrapListItem } from './styles'
import { HotelImageUrl } from '../utils'

type CategoryValue = Pick<RequestQuoteHotelRoom, 'category' | 'total_value'>

function RenderHotel({ hotel }: { hotel: RequestQuoteHotelGroup }) {
  const [defaultOption, setDefaultOption] = useState<CategoryValue>(undefined)
  const hasSelection = hotel.request_quote_hotels.some(agency =>
    agency.request_quote_hotel_rooms.some(({ selected }) => selected)
  )

  const groupRoom = useMemo<CategoryValue[]>(() => {
    const room: CategoryValue[] = []
    if (!hotel.request_quote_hotels?.length) {
      return []
    }
    hotel.request_quote_hotels.forEach(agency => {
      agency.request_quote_hotel_rooms.forEach(({ category, total_value }) => {
        if (
          room.findIndex(
            offer =>
              offer.category === category && offer.total_value === total_value
          ) <= -1
        ) {
          room.push({ category, total_value })
        }
      })
    })
    return room
  }, [hotel])

  useEffect(() => {
    if (groupRoom.length) {
      setDefaultOption(
        groupRoom.sort((a, b) => a.total_value - b.total_value)[0]
      )
    }
  }, [groupRoom])

  function selectValue(value: any) {
    setDefaultOption({ ...defaultOption, total_value: value })
  }

  function categoryChange(value: any) {
    setDefaultOption({
      category: value,
      total_value: groupRoom.filter(filter => filter.category === value)[0]
        ?.total_value
    })
  }

  if (!hotel.request_quote_hotels?.length) {
    return <></>
  }

  const { brand_name, address, category_stars, hotel_image_url } =
    hotel.request_quote_hotels[0]

  return (
    <WrapListItem isselected={hasSelection ? 1 : 0} key={brand_name}>
      <ListAntd.Item.Meta
        avatar={
          <WrapDivMeta>
            <HotelImageUrl
              url={hotel_image_url}
              style={{ maxHeight: 200, maxWidth: 200, minWidth: 100 }}
            />
          </WrapDivMeta>
        }
        title={brand_name}
        description={
          <Row gutter={24}>
            <Col span={15}>
              {address}
              <br />
              <br />
              <span>
                <Icon type="star" style={{ marginRight: 8 }} />
                <Text
                  onlyText
                  title={JSON.stringify({
                    message: 'web.services.hotels.form.stars',
                    params: { count: category_stars }
                  })}
                />
              </span>
            </Col>
            <Col span={9}>
              <div style={{ display: 'grid' }}>
                <Select
                  style={{ maxWidth: '175px' }}
                  value={defaultOption?.category || ''}
                  onChange={categoryChange}
                >
                  {groupRoom
                    .filter(
                      (offer, index) =>
                        groupRoom.findIndex(
                          item => item.category === offer.category
                        ) === index
                    )
                    .map((offer, index) => (
                      <Select.Option
                        key={index}
                        title={offer.category}
                        value={offer.category}
                      >
                        {offer.category}
                      </Select.Option>
                    ))}
                </Select>
                <Select
                  style={{ maxWidth: '175px' }}
                  value={
                    `BRL ${
                      currencyMask({
                        formatStr: true,
                        precision: 2,
                        value: defaultOption?.total_value
                      }).maskedValue
                    }` || ''
                  }
                  onChange={selectValue}
                >
                  {groupRoom
                    .filter(offer => offer.category === defaultOption?.category)
                    .map((offer, index) => {
                      const totalValue = `BRL ${
                        currencyMask({
                          formatStr: true,
                          precision: 2,
                          value: offer.total_value
                        }).maskedValue
                      }`
                      return (
                        <Select.Option
                          key={index}
                          title={totalValue}
                          value={offer.total_value}
                        >
                          {totalValue}
                        </Select.Option>
                      )
                    })}
                </Select>
              </div>
            </Col>
          </Row>
        }
      />
    </WrapListItem>
  )
}

export default RenderHotel
